import validate from "/usr/src/app/content/n3-redirections-legacy-16323ed1-2e53-49e7-a9de-3bf25b406031/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-legacy-16323ed1-2e53-49e7-a9de-3bf25b406031/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}